import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import JsonLd from '../../components/base/JsonLd';

export default function AboutPage() {
  const [isNavFixed, setIsNavFixed] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);

  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://donghua-painting.com';

  const aboutJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    '@id': `${siteUrl}/about`,
    url: `${siteUrl}/about`,
    name: '關於東樺 | 20年建築塗裝專業品牌故事',
    description: '東樺建築塗裝成立於2005年，20年專業建築外牆塗裝品牌。秉持品質第一、誠信為本理念，以專業工藝守護台灣建築之美。',
    inLanguage: 'zh-TW',
    isPartOf: { '@id': `${siteUrl}/#website` },
    about: {
      '@type': 'Organization',
      '@id': `${siteUrl}/#business`,
      name: '東樺建築塗裝有限公司',
      foundingDate: '2005',
      description: '專業建築外牆塗裝服務，以品質第一、誠信為本的經營理念，服務台灣各地建築。',
      telephone: '03-3900-250',
      email: ['tunghua69566488@gmail.com', 'sales@tung-hua.com'],
      address: {
        '@type': 'PostalAddress',
        streetAddress: '中正二街2號',
        addressLocality: '八德區',
        addressRegion: '桃園市',
        postalCode: '334',
        addressCountry: 'TW',
      },
      numberOfEmployees: { '@type': 'QuantitativeValue', value: 10 },
    },
  };

  useEffect(() => {
    document.title = '關於東樺 | 20年建築塗裝專業品牌故事 | 東樺建築塗裝';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', '東樺建築塗裝成立於2005年，20年專業建築外牆塗裝品牌。秉持品質第一、誠信為本理念，以專業工藝守護台灣建築之美。了解我們的發展歷程與核心價值。');
    }
    return () => {
      document.title = '東樺建築塗裝 | 台灣專業外牆塗裝 | 築於信任繪於精緻';
      if (metaDesc) {
        metaDesc.setAttribute('content', '東樺建築塗裝成立於2005年,擁有20年專業經驗的台灣專業建築外牆塗裝專家。採用德日進口塗料,提供高品質的建築外牆塗裝服務。');
      }
    };
  }, []);

  const values = [
    {
      icon: 'ri-shield-star-line',
      title: '品質第一',
      description: '嚴選高品質塗料,每道工序都經過嚴格的品質檢測,確保塗裝效果達到最高標準。',
      image: 'https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/1c3dda570bac72d67a38324910e3f8a6.jpeg',
    },
    {
      icon: 'ri-hand-heart-line',
      title: '誠信為本',
      description: '二十年來始終堅持誠信經營,以透明的報價與扎實的工藝,贏得客戶的信賴。',
      image: 'https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/c457385e81e179ca604a4ed8135075bb.jpeg',
    },
    {
      icon: 'ri-leaf-line',
      title: '永續發展',
      description: '採用環保水性塗料,符合台灣綠建材標準,在追求品質的同時,也為地球的永續發展盡一份心力。',
      image: 'https://public.readdy.ai/ai/img_res/f00b35d326b7dc98ec8543a59f5b2ba1.jpg',
    },
    {
      icon: 'ri-team-line',
      title: '專業團隊',
      description: '擁有經驗豐富的專業施工團隊,定期接受技術培訓,確保工藝水準與時俱進。',
      image: 'https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/ff642618c7f511711288b184d091a2e3.jpeg',
    },
  ];

  const milestones = [
    { 
      year: '2005', 
      title: '公司創立', 
      description: '東樺建築塗裝於桃園成立,開始專注於建築外牆塗裝服務。',
      image: 'https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/ff19afe6f776d688fe90388ff926042b.jpeg'
    },
    { 
      year: '2010', 
      title: '品質認證', 
      description: '取得ISO品質管理認證,建立完善的品質管控系統',
      image: 'https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/add0f9d8de4ba48378051345bf41cbfc.jpeg'
    },
    { 
      year: '2012', 
      title: '業務拓展', 
      description: '承接大型公共工程,業務範圍擴及全台各地。',
      image: 'https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/925e217b7119449284018276da45bf1c.jpeg'
    },
    { 
      year: '2015', 
      title: '技術升級', 
      description: '建立標準化施工流程。',
      image: 'https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/3a5022383a6ad6b5ed3117f56e388b18.jpeg'
    },
    { 
      year: '2020', 
      title: '環保轉型', 
      description: '全面導入環保水性塗料,響應綠色建築趨勢。',
      image: 'https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/0cd8bbe77fba2762c5aca8e5bcd01e29.jpeg'
    },
    { 
      year: '2024', 
      title: '持續創新', 
      description: '引進最新塗裝技術,持續為客戶提供更優質的服務。',
      image: 'https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/e23b42d533769463a1f5659f46edfedf.jpeg'
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <JsonLd id="about-jsonld" data={aboutJsonLd} />
      {/* Navigation */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          isNavFixed ? 'bg-white shadow-lg' : 'bg-white'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-3">
            <img
              src="https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/d57786512cad84463bdc66c219dc39c4.png"
              alt="東樺建築塗裝"
              className="h-12"
            />
          </Link>
          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className="text-sm font-medium text-gray-900 hover:text-[#D4AF37] transition-colors cursor-pointer"
            >
              首頁
            </Link>
            <Link
              to="/about"
              className="text-sm font-medium text-[#D4AF37] transition-colors cursor-pointer"
            >
              關於東樺
            </Link>
            <Link
              to="/technology"
              className="text-sm font-medium text-gray-900 hover:text-[#D4AF37] transition-colors cursor-pointer"
            >
              專業工藝
            </Link>
            <a
              href="#contact"
              className="bg-[#D4AF37] text-white px-6 py-2 rounded-full text-sm font-medium hover:bg-[#B8941F] transition-colors whitespace-nowrap cursor-pointer"
            >
              聯絡我們
            </a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative pt-32 pb-24 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-[#F8F9FA] to-white"></div>
        <div className="absolute top-0 right-0 w-1/2 h-full opacity-5">
          <div
            className="w-full h-full"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            }}
          ></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-6">
          <div className="max-w-3xl">
            <div className="inline-block px-4 py-2 bg-[#D4AF37]/10 rounded-full text-[#D4AF37] text-sm font-medium mb-6">
              關於東樺
            </div>
            <h1 className="text-6xl md:text-7xl font-bold text-gray-900 mb-8 leading-tight">
              城市的肌膚
              <br />
              <span className="text-[#D4AF37]">信任的顏色</span>
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed mb-8">
              自2005年創立以來,東樺建築塗裝始終堅持「品質第一、誠信為本」的經營理念。<br />
              我們不僅是塗裝工程的執行者,更是建築生命週期的守護者。
            </p>
            <div className="flex flex-wrap gap-12">
              <div>
                <div className="text-5xl font-bold text-[#D4AF37] mb-2">20+</div>
                <div className="text-gray-600">年專業經驗</div>
              </div>
              <div>
                <div className="text-5xl font-bold text-[#34495E] mb-2">500+</div>
                <div className="text-gray-600">完工案件</div>
              </div>
              <div>
                <div className="text-5xl font-bold text-[#D4AF37] mb-2">10+</div>
                <div className="text-gray-600">專業團隊</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Company Story */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <div className="relative">
              <div className="aspect-[3/4] w-full h-full relative overflow-hidden rounded-2xl">
                <img
                  src="https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/d23ee039914a4dc6c6414a9383ae6cc7.png"
                  alt="東樺團隊"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-8 -right-8 bg-[#D4AF37] text-white p-8 rounded-2xl shadow-2xl max-w-xs">
                <p className="text-lg font-medium leading-relaxed">
                  從結構堆疊到時間雕刻,我們用專業守護每一座建築的永恆之美。
                </p>
              </div>
            </div>

            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-8">企業精神</h2>
              <div className="space-y-6 text-gray-600 leading-relaxed text-base">
                <p>
                  自2005年創立以來,東樺建築塗裝始終堅持「品質第一、誠信為本」的經營理念。我們不僅是塗裝工程的執行者,更是建築生命週期的守護者。
                </p>
                <p>
                  每一次的塗裝,都是對建築生命的延續;每一道工序,都是對品質的承諾。從底層防水到面層抗UV,從材料選擇到施工管理,我們始終以最嚴謹的態度,為每一座建築披上最堅實的外衣。
                </p>
                <p>
                  二十年來,我們見證了台灣建築產業的發展,也參與了無數城市地標的誕生。從公共建築到教育機構,從科技廠房到住宅建案,每一個完工的案件,都是我們榮耀的印記,也是客戶信任的證明。
                </p>
                <p className="text-lg font-medium text-[#D4AF37]">
                  「築於信任,繪於精緻」不只是我們的標語,更是二十年來不變的承諾。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="py-24 bg-gradient-to-br from-[#F8F9FA] to-[#E8E9EB]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-gray-900 mb-6">核心價值</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              四大核心價值,構築東樺二十年來的專業基石
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {values.map((value, index) => (
              <div
                key={index}
                className="group relative rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2 cursor-pointer"
              >
                {/* 背景圖片 */}
                <div className="absolute inset-0">
                  <img
                    src={value.image}
                    alt={value.title}
                    className="w-full h-full object-cover object-top opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                  />
                  <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                </div>
                
                {/* 預設白色背景 */}
                <div className="absolute inset-0 bg-white group-hover:opacity-0 transition-opacity duration-500"></div>
                
                {/* 內容 */}
                <div className="relative p-10 min-h-[280px] flex flex-col justify-center">
                  <div className="w-16 h-16 bg-[#D4AF37]/10 group-hover:bg-white/20 rounded-full flex items-center justify-center mb-6 transition-colors duration-500">
                    <i className={`${value.icon} text-3xl text-[#D4AF37] group-hover:text-white transition-colors duration-500`}></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 group-hover:text-white mb-4 transition-colors duration-500">{value.title}</h3>
                  <p className="text-gray-600 group-hover:text-white/90 leading-relaxed transition-colors duration-500">{value.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="py-24 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-gray-900 mb-6">發展歷程</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              二十年的堅持與創新,見證台灣建築塗裝產業的發展
            </p>
          </div>

          <div className="relative">
            <div className="absolute left-1/2 transform -translate-x-1/2 top-0 bottom-0 w-0.5 bg-[#D4AF37]/30"></div>

            {milestones.map((milestone, index) => (
              <div key={index} className="relative mb-16">
                <div className={`flex items-center gap-8 ${index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'}`}>
                  {/* 文字卡片 */}
                  <div className="w-[calc(50%-2rem)]">
                    <div className={`bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all ${index % 2 === 0 ? 'text-right' : 'text-left'}`}>
                      <div className="text-4xl font-bold text-[#D4AF37] mb-4">{milestone.year}</div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-3">{milestone.title}</h3>
                      <p className="text-gray-600 leading-relaxed">{milestone.description}</p>
                    </div>
                  </div>

                  {/* 中間圓點 */}
                  <div className="absolute left-1/2 transform -translate-x-1/2 w-4 h-4 bg-[#D4AF37] rounded-full border-4 border-white shadow-lg z-10"></div>

                  {/* 圖片 */}
                  <div className="w-[calc(50%-2rem)]">
                    <div className="rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all">
                      <div className="w-full aspect-video relative">
                        <img
                          src={milestone.image}
                          alt={milestone.title}
                          className="w-full h-full object-cover object-top"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Vision */}
      <section className="py-24 bg-[#34495E] text-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-5xl font-bold mb-8">品牌願景</h2>
              <div className="space-y-6 text-white/80 leading-relaxed text-lg">
                <p>
                  我們相信,建築不只是鋼筋混凝土的組合,更是承載人們生活記憶的容器。每一座建築都有它的故事,每一面牆都見證著時間的流逝。
                </p>
                <p>
                  東樺的願景,是成為台灣最值得信賴的建築塗裝品牌。我們不追求規模的擴張,而專注於品質的提升;我們不只是完成一個個工程案件,更是在為城市創造永恆的風景。
                </p>
                <p>
                  未來,我們將持續引進最先進的塗裝技術,培育更專業的施工團隊,為台灣的建築美學與永續發展,貢獻我們的專業與熱情。
                </p>
                <p className="text-2xl font-bold text-[#D4AF37]">
                  築於信任,立於精緻,傳於永恆。
                </p>
              </div>
            </div>

            <div className="relative">
              <div className="aspect-[4/3] w-full h-full relative overflow-hidden rounded-2xl">
                <img
                  src="https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/76e52b156022e636965eb79a7b376d4e.jpeg"
                  alt="品牌願景"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Video Section */}
      <section className="py-24 bg-gradient-to-br from-[#F8F9FA] to-white">
        <div className="max-w-5xl mx-auto px-6">
          <div className="text-center mb-12">
            <div className="inline-block px-4 py-2 bg-[#D4AF37]/10 rounded-full text-[#D4AF37] text-sm font-medium mb-6">
              品牌影片
            </div>
            <h2 className="text-5xl font-bold text-gray-900 mb-6">走進東樺的世界</h2>
            <p className="text-xl text-gray-600 leading-relaxed">
              透過影像，感受我們二十年來對建築美學的堅持與熱情
            </p>
          </div>
          <div className="aspect-video bg-[#34495E]/10 rounded-2xl flex items-center justify-center border-2 border-[#D4AF37]/20 overflow-hidden relative group cursor-pointer" onClick={() => setShowVideoModal(true)}>
            <img
              src="https://readdy.ai/api/search-image?query=professional%20construction%20team%20working%20on%20building%20exterior%20painting%20scaffolding%20golden%20hour%20warm%20lighting%20Taiwan%20architecture%20craftsmanship%20teamwork%20professional%20coating%20work%20cinematic%20wide%20angle&width=1200&height=675&seq=about-video-thumb&orientation=landscape"
              alt="東樺品牌影片"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center">
              <div className="w-20 h-20 bg-[#D4AF37] rounded-full flex items-center justify-center mb-4 shadow-2xl group-hover:scale-110 transition-transform">
                <i className="ri-play-fill text-4xl text-white ml-1"></i>
              </div>
              <p className="text-white font-medium text-lg">點擊播放品牌影片</p>
            </div>
          </div>
        </div>
      </section>

      {/* Video Modal */}
      {showVideoModal && (
        <div
          className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center p-4 animate-fadeIn"
          onClick={() => setShowVideoModal(false)}
        >
          <button
            onClick={() => setShowVideoModal(false)}
            className="absolute top-6 right-6 w-12 h-12 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white/20 transition-all cursor-pointer z-10"
          >
            <i className="ri-close-line text-white text-2xl"></i>
          </button>
          <div className="max-w-6xl w-full" onClick={(e) => e.stopPropagation()}>
            <div className="text-center mb-8">
              <h3 className="text-4xl font-bold text-white mb-4">東樺建築塗裝 · 品牌形象影片</h3>
              <p className="text-white/60 text-lg">築於信任，繪於精緻 — 用塗料書寫城市的故事</p>
            </div>
            <div className="aspect-video bg-black rounded-2xl overflow-hidden shadow-2xl">
              <iframe
                className="w-full h-full"
                src="https://www.youtube.com/embed/nKJwzpE8o6w"
                title="東樺建築塗裝品牌影片"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="text-center mt-8">
              <p className="text-white/60 text-sm">點擊任意處關閉</p>
            </div>
          </div>
        </div>
      )}

      {/* CTA */}
      <section className="py-24 bg-gradient-to-br from-[#F8F9FA] to-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-5xl font-bold text-gray-900 mb-8">
            加入東樺,共創未來
          </h2>
          <p className="text-xl text-gray-600 mb-12 leading-relaxed">
            我們持續尋找對建築美學有熱情、對品質有堅持的夥伴。<br />
            如果您認同我們的理念,歡迎加入東樺的專業團隊。
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a
              href="#contact"
              className="bg-[#D4AF37] text-white px-8 py-4 rounded-full text-base font-medium hover:bg-[#B8941F] transition-all cursor-pointer whitespace-nowrap"
            >
              聯絡我們
            </a>
            <Link
              to="/technology"
              className="border-2 border-[#34495E] text-[#34495E] px-8 py-4 rounded-full text-base font-medium hover:bg-[#34495E] hover:text-white transition-all cursor-pointer whitespace-nowrap"
            >
              了解我們的工藝
            </Link>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-16">
            <div>
              <div className="inline-block px-4 py-2 bg-[#D4AF37]/10 rounded-full text-[#D4AF37] text-sm font-medium mb-6">
                聯絡我們
              </div>
              <h2 className="text-5xl font-bold text-gray-900 mb-8 leading-tight">
                開始您的
                <br />
                建築美學之旅
              </h2>
              <p className="text-lg text-gray-600 mb-12 leading-relaxed">
                無論是新建工程或是老屋翻新,我們都能為您提供最專業的塗裝解決方案。
              </p>

              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#D4AF37]/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-xl text-[#D4AF37]"></i>
                  </div>
                  <div>
                    <div className="text-sm text-gray-500 mb-1">聯絡電話</div>
                    <div className="text-lg font-medium text-gray-900">03-3900-250</div>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#D4AF37]/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-xl text-[#D4AF37]"></i>
                  </div>
                  <div>
                    <div className="text-sm text-gray-500 mb-1">電子郵件</div>
                    <div className="text-lg font-medium text-gray-900">tunghua69566488@gmail.com</div>
                    <div className="text-lg font-medium text-gray-900">sales@tung-hua.com</div>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#D4AF37]/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-xl text-[#D4AF37]"></i>
                  </div>
                  <div>
                    <div className="text-sm text-gray-500 mb-1">公司地址</div>
                    <div className="text-lg font-medium text-gray-900">台灣 334桃園市八德區中正二街2號</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-[#F8F9FA] to-[#E8E9EB] rounded-2xl p-8">
              <form className="space-y-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    姓名
                  </label>
                  <input
                    type="text"
                    name="name"
                    className="w-full px-4 py-3 border-b-2 border-[#D4AF37] bg-transparent focus:outline-none focus:border-[#B8941F] transition-colors"
                    placeholder="請輸入您的姓名"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    電子郵件
                  </label>
                  <input
                    type="email"
                    name="email"
                    className="w-full px-4 py-3 border-b-2 border-[#D4AF37] bg-transparent focus:outline-none focus:border-[#B8941F] transition-colors"
                    placeholder="請輸入您的電子郵件"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    聯絡電話
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    className="w-full px-4 py-3 border-b-2 border-[#D4AF37] bg-transparent focus:outline-none focus:border-[#B8941F] transition-colors"
                    placeholder="請輸入您的聯絡電話"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    諮詢內容
                  </label>
                  <textarea
                    name="message"
                    rows={4}
                    maxLength={500}
                    className="w-full px-4 py-3 border-b-2 border-[#D4AF37] bg-transparent focus:outline-none focus:border-[#B8941F] transition-colors resize-none"
                    placeholder="請描述您的需求..."
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="w-full bg-[#D4AF37] text-white py-4 rounded-full font-medium hover:bg-[#B8941F] transition-all cursor-pointer whitespace-nowrap"
                >
                  送出諮詢
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1A1A1A] text-white">
        <div className="py-16">
          <div className="max-w-7xl mx-auto px-6 text-center">
            <h3 className="text-4xl font-bold text-[#D4AF37] mb-4 tracking-wider">
              專業塗裝 · 誠信永續 · 築出永恆的風景
            </h3>
          </div>
        </div>

        <div className="border-t border-white/10">
          <div className="max-w-7xl mx-auto px-6 py-12">
            <div className="grid md:grid-cols-4 gap-12">
              <div>
                <img
                  src="https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/d57786512cad84463bdc66c219dc39c4.png"
                  alt="東樺建築塗裝"
                  className="h-12 mb-4"
                />
                <p className="text-white/60 text-sm leading-relaxed">
                  二十年專注建築外牆塗裝,以專業工藝守護每一座建築的生命。
                </p>
              </div>

              <div>
                <h4 className="text-lg font-bold mb-4">快速連結</h4>
                <ul className="space-y-2">
                  <li>
                    <Link
                      to="/"
                      className="text-white/60 hover:text-[#D4AF37] transition-colors text-sm cursor-pointer"
                    >
                      首頁
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/about"
                      className="text-white/60 hover:text-[#D4AF37] transition-colors text-sm cursor-pointer"
                    >
                      關於東樺
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/technology"
                      className="text-white/60 hover:text-[#D4AF37] transition-colors text-sm cursor-pointer"
                    >
                      專業工藝
                    </Link>
                  </li>
                </ul>
              </div>

              <div>
                <h4 className="text-lg font-bold mb-4">聯絡資訊</h4>
                <ul className="space-y-2 text-sm">
                  <li className="flex items-center gap-2 text-white/60">
                    <i className="ri-phone-line"></i>
                    03-3900-250
                  </li>
                  <li className="flex items-center gap-2 text-white/60">
                    <i className="ri-mail-line"></i>
                    tunghua69566488@gmail.com
                  </li>
                  <li className="flex items-center gap-2 text-white/60">
                    <i className="ri-mail-line"></i>
                    sales@tung-hua.com
                  </li>
                  <li className="flex items-center gap-2 text-white/60">
                    <i className="ri-map-pin-line"></i>
                    台灣 334桃園市八德區中正二街2號
                  </li>
                </ul>
              </div>

              <div>
                <h4 className="text-lg font-bold mb-4">追蹤我們</h4>
                <div className="flex gap-3">
                  <a
                    href="#"
                    className="w-10 h-10 rounded-full border border-[#D4AF37] flex items-center justify-center hover:bg-[#D4AF37] transition-all cursor-pointer"
                  >
                    <i className="ri-facebook-fill"></i>
                  </a>
                  <a
                    href="#"
                    className="w-10 h-10 rounded-full border border-[#D4AF37] flex items-center justify-center hover:bg-[#D4AF37] transition-all cursor-pointer"
                  >
                    <i className="ri-line-fill"></i>
                  </a>
                  <a
                    href="#"
                    className="w-10 h-10 rounded-full border border-[#D4AF37] flex items-center justify-center hover:bg-[#D4AF37] transition-all cursor-pointer"
                  >
                    <i className="ri-instagram-line"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 bg-[#0D0D0D]">
          <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-sm text-white/40">
              © 2024 東樺建築塗裝有限公司. All rights reserved.
            </div>
            <div className="flex items-center gap-4">
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-white/40 hover:text-[#D4AF37] transition-colors cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
